var map = {
	".": 18305,
	"./": 18305,
	"./App": 7564,
	"./App.css": 93508,
	"./App.js": 7564,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./about": 95779,
	"./about.css": 14277,
	"./about.js": 95779,
	"./general": 78573,
	"./general.css": 47459,
	"./general.js": 78573,
	"./img/Anran_CV.pdf": 78412,
	"./img/CCS25.png": 521,
	"./img/CHI 25 LBW.png": 87053,
	"./img/CHI2024.png": 91019,
	"./img/CSS.png": 75684,
	"./img/IUI23.png": 41689,
	"./img/IUI26.png": 44028,
	"./img/IV19_offroad.PNG": 4115,
	"./img/UBI.png": 47402,
	"./img/UBICOMP24.png": 17937,
	"./img/X.png": 64384,
	"./img/back.png": 36637,
	"./img/background.jpg": 52250,
	"./img/background_old.jpg": 29142,
	"./img/email.png": 91959,
	"./img/feather-pen.png": 96101,
	"./img/github.png": 11061,
	"./img/google-scholar.png": 21986,
	"./img/imwut21_syncup.jpg": 49440,
	"./img/instruction1.png": 80271,
	"./img/instruction2.png": 82962,
	"./img/resume.png": 53158,
	"./img/selfie0.jpg": 50086,
	"./img/ubicomp21demo.jpg": 68695,
	"./img/user.png": 79948,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./pdf/Anran_CV.pdf": 97093,
	"./pdf/CHI2024.pdf": 65494,
	"./pdf/UBI_Anran.pdf": 28241,
	"./publication": 44462,
	"./publication.css": 21389,
	"./publication.js": 44462,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;